export enum ToothDetailContentType {
	GENERAL = 'GENERAL',
	PATHOLOGY = 'PATHOLOGY',
	RESTORATION = 'RESTORATION',
	PERIODONTAL = 'PERIODONTAL',
}
